/* YoloLife — lightbox: native <dialog> opened by any [data-yl-lightbox-trigger]. */
(function () {
  'use strict';

  const dialog = document.querySelector('[data-yl-lightbox]');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const imgEl = dialog.querySelector('[data-yl-lightbox-img]');
  const numEl = dialog.querySelector('[data-yl-lightbox-num]');
  const titleEl = dialog.querySelector('[data-yl-lightbox-title]');
  const metaEl = dialog.querySelector('[data-yl-lightbox-meta]');
  const closeBtn = dialog.querySelector('[data-yl-lightbox-close]');
  const placeholderSrc = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

  const open = (trigger) => {
    const img = trigger.querySelector('img');
    if (!img) return;
    imgEl.src = img.currentSrc || img.src;
    imgEl.alt = img.alt || '';
    numEl.textContent = trigger.dataset.num || '';
    titleEl.textContent = trigger.dataset.title || '';
    metaEl.textContent = trigger.dataset.meta || '';
    dialog.showModal();
    document.body.classList.add('yl-lightbox-open');
  };

  const close = () => {
    if (dialog.open) dialog.close();
    imgEl.src = placeholderSrc;
    document.body.classList.remove('yl-lightbox-open');
  };

  // Delegated click — anything with data-yl-lightbox-trigger opens.
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-yl-lightbox-trigger]');
    if (trigger) {
      e.preventDefault();
      open(trigger);
    }
  });

  closeBtn?.addEventListener('click', close);

  // Click outside content area closes
  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) close();
  });

  // Native Escape already closes <dialog>; sync body class on cancel/close
  dialog.addEventListener('close', () => {
    imgEl.src = placeholderSrc;
    document.body.classList.remove('yl-lightbox-open');
  });
})();
